var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.75V8.75C17.5 9.08152 17.6317 9.39946 17.8661 9.63388C18.1005 9.8683 18.4185 10 18.75 10H23.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 26.25H8.75C8.08696 26.25 7.45107 25.9866 6.98223 25.5178C6.51339 25.0489 6.25 24.413 6.25 23.75V6.25C6.25 5.58696 6.51339 4.95107 6.98223 4.48223C7.45107 4.01339 8.08696 3.75 8.75 3.75H17.5L23.75 10V23.75C23.75 24.413 23.4866 25.0489 23.0178 25.5178C22.5489 25.9866 21.913 26.25 21.25 26.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2256 16.175C13.2256 16.3983 13.1739 16.6017 13.0706 16.785C12.9672 16.965 12.8139 17.1083 12.6106 17.215C12.4106 17.3217 12.1672 17.375 11.8806 17.375H11.4406V18.5H10.3306V14.96H11.8806C12.3139 14.96 12.6456 15.07 12.8756 15.29C13.1089 15.51 13.2256 15.805 13.2256 16.175ZM11.7556 16.5C11.9856 16.5 12.1006 16.3917 12.1006 16.175C12.1006 15.9583 11.9856 15.85 11.7556 15.85H11.4406V16.5H11.7556ZM15.0526 14.96C15.4226 14.96 15.746 15.035 16.0226 15.185C16.3026 15.335 16.5176 15.5433 16.6676 15.81C16.8176 16.0767 16.8926 16.38 16.8926 16.72C16.8926 17.0567 16.8176 17.36 16.6676 17.63C16.5176 17.9 16.3026 18.1133 16.0226 18.27C15.746 18.4233 15.4226 18.5 15.0526 18.5H13.5776V14.96H15.0526ZM14.9526 17.51C15.2026 17.51 15.401 17.4417 15.5476 17.305C15.6943 17.1683 15.7676 16.9733 15.7676 16.72C15.7676 16.4667 15.6943 16.2717 15.5476 16.135C15.401 15.9983 15.2026 15.93 14.9526 15.93H14.6876V17.51H14.9526ZM19.7935 14.96V15.84H18.4035V16.33H19.4035V17.165H18.4035V18.5H17.2935V14.96H19.7935Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.2278955420696059d3719229c1c8052b.svg";
export { ForwardRef as ReactComponent };